module.exports = __webpack_public_path__ + "static/media/villageTheme.29c84be8.mp3";